<template>
    <footer>
    <nav class="navbar navbar-expand-sm navbar-dark bg-dark">
        <div class="container">
            <address>
                <h5>Freiberuflicher Medieninformatiker (BA)</h5>
                <h4>{{$root.contact.name}}</h4>
                {{$root.contact.street}}<br>
                {{$root.contact.zip}} {{$root.contact.city}} <br>
                <!--
                <a :href="$root.contact.phonelink"><i class="material-icons">call</i> {{$root.contact.phone}} </a><br>
                -->
                <a :href="'mailto:' + $root.contact.email"><i class="material-icons">mail_outline</i> {{$root.contact.email}} </a>
            </address>

            <div class="social-nav">
                <social-navigation class="ml-auto">
                    <li class="nav-item"><router-link to="/datenschutz" class="nav-link">Impressum &amp; Datenschutz</router-link></li>
                </social-navigation>
            </div>
        </div>
    </nav>
</footer>

</template>

<script>
import SocialNavigation from './SocialNavigation'
export default {
    components: {
        SocialNavigation
    }
}
</script>
